const exported = {
  DEGREE_PARTNER_SHORTNAMES: ['asu', 'hec', 'illinois', 'london'],
};

export default exported;
export const { DEGREE_PARTNER_SHORTNAMES } = exported;
